import AppConfig from "../../../../config/AppConfig";

const customEmojis = [
  {
    name: "Mana",
    short_names: ["mana"],
    text: "",
    emoticons: [],
    keywords: ["mana"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_mana`,
    customCategory: "Mana",
  },
  {
    name: "Chrome",
    short_names: ["chrome"],
    text: "",
    emoticons: [],
    keywords: ["chrome"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_chrome`,
    customCategory: "Mana",
  },
  {
    name: "Essentials",
    short_names: ["essentials"],
    text: "",
    emoticons: [],
    keywords: ["essentials"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_essentials`,
    customCategory: "Mana",
  },
  {
    name: "Fun",
    short_names: ["fun"],
    text: "",
    emoticons: [],
    keywords: ["fun"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_fun`,
    customCategory: "Mana",
  },
  {
    name: "Fun",
    short_names: ["funl"],
    text: "",
    emoticons: [],
    keywords: ["fun"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_funl`,
    customCategory: "Mana",
  },
  {
    name: "Google Calendar",
    short_names: ["googlecal"],
    text: "",
    emoticons: [],
    keywords: ["google", "calendar"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_googlecal`,
    customCategory: "Mana",
  },
  {
    name: "Health",
    short_names: ["health"],
    text: "",
    emoticons: [],
    keywords: ["health"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_health`,
    customCategory: "Mana",
  },
  {
    name: "Health",
    short_names: ["healthl"],
    text: "",
    emoticons: [],
    keywords: ["health"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_healthl`,
    customCategory: "Mana",
  },
  {
    name: "MacOS",
    short_names: ["macos"],
    text: "",
    emoticons: [],
    keywords: ["mac", "macos"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_macos`,
    customCategory: "Mana",
  },
  {
    name: "Other",
    short_names: ["other"],
    text: "",
    emoticons: [],
    keywords: ["other"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_other`,
    customCategory: "Mana",
  },
  {
    name: "Outlook",
    short_names: ["outlook"],
    text: "",
    emoticons: [],
    keywords: ["outlook", "microsoft"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_outlook`,
    customCategory: "Mana",
  },
  {
    name: "People",
    short_names: ["people"],
    text: "",
    emoticons: [],
    keywords: ["people", "pets"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_people`,
    customCategory: "Mana",
  },
  {
    name: "Slack",
    short_names: ["slack"],
    text: "",
    emoticons: [],
    keywords: ["slack"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_slack`,
    customCategory: "Mana",
  },
  {
    name: "Windows",
    short_names: ["windows"],
    text: "",
    emoticons: [],
    keywords: ["windows", "microsoft"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_windows`,
    customCategory: "Mana",
  },
  {
    name: "Work",
    short_names: ["work"],
    text: "",
    emoticons: [],
    keywords: ["work"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_work`,
    customCategory: "Mana",
  },
  {
    name: "Work",
    short_names: ["workl"],
    text: "",
    emoticons: [],
    keywords: ["work"],
    imageUrl: `${AppConfig.API_URL}/image?emoji_workl`,
    customCategory: "Mana",
  },
];

export default customEmojis;
